module.exports = __webpack_public_path__ + "static/media/phone-call.65b8bace.svg";